<div class="flex flex-col align-middle relative items-center text-slate-900">
    <button (click)="onEditDeckClicked($event)">
        <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
            <title>Options</title>
            @if (displayOptions) {
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
            } @else {
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="editSvgIcon" />
            }
        </svg>
    </button>
    @if (displayOptions) {
        <div #dialog class="absolute w-[350px] top-[34px] right-0 sm:right-[-6px] bg-slate-100 z-30 shadow rounded-lg">
            <div class="flex flex-col">
                <div class="flex flex-col pr-2">
                    <!-- Name -->
                    <div class="grid grid-cols-3">
                        <div class="text-right p-2 pt-3 border-r">Name</div>
                        <div class="p-1 pt-2 col-span-2">
                            <input #nameChangeInput class="bg-slate-50 shadow-sm w-full p-1 pl-2" [attr.value]="deck.name" [attr.disabled]="isUpdating ? true : undefined">
                        </div>
                    </div>
                    <!-- Group -->
                    <div class="grid grid-cols-3">
                        <div class="text-right p-2 border-r">Group</div>
                        <div class="p-1 col-span-2">
                            <input #groupChangeInput class="bg-slate-50 shadow-sm w-full p-1 pl-2" [attr.value]="deck.group" [attr.disabled]="isUpdating ? true : undefined" list="deckGroups">
                            <datalist id="deckGroups">
                                @for (group of deckGroups ; track group) {
                                    <option [attr.value]="group"></option>
                                }
                            </datalist>
                        </div>
                    </div>
                    <!-- Type -->
                    <div class="grid grid-cols-3">
                        <div class="text-right p-2 border-r">Type</div>
                        <div class="p-1 col-span-2">
                            <select #deckTypeSelect class="p-1 bg-slate-50 w-full shadow-sm" [attr.disabled]="isUpdating ? true : undefined">
                                @for (deckType of deckTypes ; track deckType) {
                                    <option value="{{ deckType }}" [attr.selected]="deckType === deck.type ? true : null">{{ deckType }}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <!-- Visibility -->
                    <div class="grid grid-cols-3">
                        <div class="text-right p-2 border-r">Visibility</div>
                        <div class="p-1 col-span-2">
                            <select #visibilitySelect class="p-1 bg-slate-50 w-full shadow-sm" [attr.disabled]="isUpdating ? true : undefined">
                                @for (visibilityType of visibilityTypes ; track visibilityType[0]) {
                                    <option value="{{ visibilityType[0] }}" [attr.selected]="visibilityType[0] === deck.visibility ? true : null">{{ visibilityType[1] }}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <!-- Color -->
                    <div class="grid grid-cols-3">
                        <div class="text-right p-2 border-r">Banner Color</div>
                        <div class="p-2 col-span-2 flex flex-row gap-2 items-center align-middle">
                            <div class="flex align-middle items-center">
                                <label class="w-5 h-5 rounded-sm shadow-sm" [style.background-color]="deckPreviewColor" [attr.disabled]="isUpdating ? true : undefined">
                                    <input #colorChangeInput class="invisible" type="color" size="0" width="0" height="0" [attr.value]="deckPreviewColor" (input)="onColorChange(colorChangeInput.value)" (change)="onColorSet(colorChangeInput.value)">
                                </label>
                            </div>
                            <div class="grow">{{ deckPreviewColor }}</div>
                            @if (colorHistory.length) {
                                <div class="pr-7">
                                    <button (click)="onUndoColorClicked()" class="w-5 h-5 p-1" [attr.disabled]="isUpdating ? true : undefined">
                                        <svg class="w-4 h-4 fill-none stroke-ponder hover:stroke-ponder-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2">
                                            <title>Undo</title>
                                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="undoSvgIcon" />
                                        </svg>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <!-- Cancel and Save -->
                <div class="grid grid-cols-2 text-slate-50 stroke-slate-50 bg-ponder-xlight p-2 rounded-b">
                    <button (click)="onCancelClicked()" class="flex flex-row gap-2 items-center align-middle justify-center group hover:cursor-pointer hover:text-ponder-bright hover:stroke-ponder-bright">
                        <div>
                            Cancel
                        </div>
                    </button>
                    <button (click)="onSaveClicked()" class="flex flex-row gap-2 items-center align-middle justify-center group hover:cursor-pointer hover:text-ponder-bright hover:stroke-ponder-bright">
                        <div>
                            Save
                        </div>
                    </button>
                </div>
            </div>
        </div>
    }
</div>
<ng-template #deleteConfirmationContainer></ng-template>